export default {
  title: '素材汇总',
  playableTitle: '可玩广告',
  materialTitle: '图片&视频',
  materialType: {
    image: '图片',
    video: '视频',
  },
  content: {
    prepend:
      '列表内为Mindworks已制作好的素材，您可选择直接推送。推送成功后，素材将会直接上传到',
    append: '的素材库。',
  },
  selfService: 'Mintegral广告主自助投放平台',
  searchFilterLabel: {
    search: '搜索',
    productName: '产品名称',
    templateName: '创意方向名称',
    templateId: '创意方向ID',
    materialName: '项目名称',
    materialId: '项目 ID',
    versionName: '版本名称',
    dcoId: 'DCOID',
    network: '选择渠道',
  },
  batchPush: '批量推送',
  playableType: {
    normal: '普通制作',
    dco: 'DCO制作',
  },
  table: {
    column: {
      playableName: '产品信息/模板名称',
      versionCount: '版本数量',
      materialType: '模板类型',
      language: '语言',
      network: '渠道',
      platform: '平台',
      options: '操作',
      versionName: '版本名称',
      deliveryTime: '交付时间',
      dcoId: 'DCOID',
      materialName: '产品名称/模板ID',
      hideVersion: '收起版本',
      showVersion: '展开版本',
    },
    loadMore: '加载更多',
  },
}
